// DEPRECATEME: since [Release 22]
import ProductsAndServicesTab from './ProductsAndServicesTab';

export default ProductsAndServicesTab;
// End deprecation
